import HomeIcon from '@mui/icons-material/Home';
import HtmlIcon from '@mui/icons-material/Html';
import CssIcon from '@mui/icons-material/Css';
import PhpIcon from '@mui/icons-material/Php';
import CodeIcon from '@mui/icons-material/Code';
import LanIcon from '@mui/icons-material/Lan';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';


export const categories = [
  { name: 'New', icon: <HomeIcon />, },
  { name: 'MySQL', icon: <CodeIcon />, },
  { name: 'ReactJS', icon: <CodeIcon />, },
  { name: 'NextJS', icon: <CodeIcon />, },
  { name: 'Pen-Testing', icon: <CodeIcon /> },
  { name: 'Ethical-Hacking', icon: <CodeIcon />, },
  { name: 'HTML', icon: <HtmlIcon />, },
  { name: 'CSS', icon: <CssIcon />, },
  { name: 'PHP', icon: <PhpIcon />, },
  { name: 'Network', icon: <LanIcon />, },
  { name: 'Coding', icon: <DeveloperModeIcon />, },
];

export const demoThumbnailUrl = 'https://i.ibb.co/G2L2Gwp/API-Course.png';
export const demoChannelUrl = '/channel/UCmXmlB4-HJytD7wek0Uo97A';
export const demoVideoUrl = '/video/GDa8kZLNhJ4';
export const demoChannelTitle = 'JavaScript Mastery';
export const demoVideoTitle = 'Build and Deploy 5 JavaScript & React API Projects in 10 Hours - Full Course | RapidAPI';
export const demoProfilePicture = 'http://dergipark.org.tr/assets/app/images/buddy_sample.png'